<template>
    <article class="doc-article">
		<p>欢迎阅读本隐私政策！本政策适用于北京动态时序科技有限公司（以下简称“动态时序”）所有并运营的官方网站（网址为www.workatdata.com，包括任何继承、重命名网站和任何子域名），以及本网站内所包含的所有产品及服务。动态时序十分重视对用户隐私的保护，保护用户隐私是动态时序的一项基本政策。本网站主要面向企业用户，本政策主要针对用户注册使用本网站时涉及到个人信息的部分。本政策将帮助您了解以下内容：</p>
		<p>1.我们收集哪些用户信息及如何使用收集的信息</p>
		<p>2.我们如何委托处理、共享、转让、公开披露您的用户信息</p>
		<p>3.我们如何保护、存储、删除您的用户信息</p>
		<p>4.Cookie和同类技术的使用</p>
		<p>5.您的权利</p>
		<p>6.我们如何处理儿童的个人信息</p>
		<p>7.您的个人信息如何在全球范围转移</p>
		<p>8.本政策如何更新</p>
		<p>9.如何联系我们</p>
		<p>动态时序深知个人信息对您的重要性，并会尽全力保护您的个人信息安全可靠。我们致力于维持您对我们的信任，恪守一下原则，保护您的个人信息：权责一致原则、目的明确原则、选择同意原则、最小必要原则、确保安全原则、主体参与原则、公开透明原则等。同时，动态时序承诺，我们将按业界成熟的安全标准，采取相应的安全保护措施来保护您的个人信息。</p>
		<p>请在使用我们的产品或服务前，仔细阅读并了解本《隐私政策》。</p>
		<p>以下为详细内容：</p>
		<h5>1.我们收集哪些用户信息及如何使用收集的信息</h5>
		<p>1.1.当您需要注册动态时序账户时，我们可能会收集这些基本信息，否则将无法正常使用我们的产品或服务：您通过手机号码注册账户时，需要收集您的中国境内手机号码、企业名称和邮箱地址。您的账号是您在本网站的标识，不可修改；您的用户名由您自己设置，可以修改。</p>
		<p>1.2.为了交易安全合规，您在购买/使用某些动态时序产品或服务前，我们可能会要求您必须对您的账户进行企业认证。企业认证时可能会收集这些信息：需要提供公司的名称、法定代表人、统一社会信用代码、公司地址、所在部门、应用场景和营业执照照片。</p>
		<p>1.3.除上述信息种类和使用方式外，我们可能收集的信息种类和使用方式还有如下情形：</p>
		<p>1.3.1.您的中国境内手机号码，用于账户注册、登录等场景下需要接收必要的验证码推送、密钥接收；为更好的向您服务，可能向您发送业务资源预警等必要的与您使用的产品相关的通知信息；为客服或销售人员与您进行沟通，如客户调查、服务调查、咨询投诉等；</p>
		<p>1.3.2.您的邮箱地址，与您的手机号码用途类似，可能用于账户注册等场景下接收必要的验证码推送；为更好的向您服务，可能向您发送业务资源预警等必要的通知信息；为客服或销售人员与您进行沟通，如客户调查、服务调查、咨询投诉等；可能向您发送合同文本或其他文件材料；</p>
		<p>1.3.3.当您使用我们的网站服务时，我们会自动收集网络日志，包括登录日志和操作日志，例如登录时间、登录状态、登录方式、IP地址、登录城市、浏览器类型、操作的网页记录等，用于完善我们的服务，如核对业务信息、优化产品和服务；需要说明的是，单独的登录日志和操作日志信息等是无法识别特定自然人身份的信息。如果我们将这类信息与其他信息结合用于识别特定自然人身份，或者将其与个人信息结合使用，则在结合使用期间，这类信息将被视为个人信息，除取得您授权或法律法规另有规定外，我们会将该类个人信息做去标识化处理。</p>
		<p>1.3.4.您所在的省份和地市，不包含您的具体定位，以方便客服或销售根据您所在城市有针对性的给您提供更好的服务，或用于对我们的客户群体分布进行内部分析；</p>
		<p>1.3.5.如果您和我们需要因业务往来提供您的银行账号，我们会告知您提供的银行账户，同时您在本网站生成的账号下的账户中的财产信息我们需予以记录和保留（仅限于用户在动态时序网站上充值和消费的财产）。有时您向您的账号充值时，我们可能需要您提供您充值时使用的支付宝、微信、银行等转账信息，如交易流水号和付款凭证，用以证明您的充值情况。</p>
		<p>1.3.6.我们可能已用户信息统计数据为基础、设计、开发、推广全新的产品及服务；我们会对我们的服务使用情况进行统计，并可能会与公众或第三方分享这些统计信息，但这些统计信息不包含您的任何身份识别信息。</p>
		<p>1.3.7.部分产品或服务可能需要上述信息以外的其他信息，若有需要收集，我们会另外明确告知您并征得您的同意。</p>
		<p>1.4.征得授权同意的例外</p>
		<p>1.4.1.与国家安全、国防安全有关的；</p>
		<p>1.4.2.与公共安全、公共卫生、重大公共利益有关的；</p>
		<p>1.4.3.与犯罪侦查、起诉、审判和判决执行等有关的；</p>
		<p>1.4.4.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>1.4.5.所收集的个人信息是个人信息主体自行向社会公众公开的；</p>
		<p>1.4.6.从合法公开披露的信息中收集的个人信息，如合法的新闻报道、政府信息公开等渠道；</p>
		<p>1.4.7.根据个人信息主体要求签订和履行合同所必需的；</p>
		<p>1.4.8.用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</p>
		<p>1.4.9.学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</p>
		<p>1.4.10.法律法规规定的其他情形。</p>
		<h5>2.我们如何委托处理、共享、转让、公开披露您的用户信息</h5>
		<p>2.1.委托处理</p>
		<p>本业务功能中某些具体的模块或功能由我们外部供应商提供。对我们委托处理个人信息的公司、组织和个人，我们会与其签署严格的保密协定，要求他们按照我们的要求、本政策以及其他任何相关的保密和安全措施来处理个人信息，并且要求其在委托关系解除时不再存储相应个人信息。</p>
		<p>2.2.共享</p>
		<p>我们不会与本公司以外的任何公司、组织和个人共享您的个人信息，除非以下情况：</p>
		<p>2.2.1.获得您的明确授权同意；</p>
		<p>2.2.2.根据适用的法律法规、或按政府主管部门强制性要求的情况下进行提供；</p>
		<p>2.2.3.为实现我们的产品或服务的核心功能所必要；</p>
		<p>2.2.4.符合与您签署的相关协议（包括在签署的电子协议以及相应的在线规则）或其他的法律文件约定所提供；</p>
		<p>2.2.5.我们可能会将您的个人信息与我们的关联方（仅限于有控制权的关联方）共享。但我们只会共享必要的个人信息，且受本隐私政策中所有声明目的的约束。我们的关联方如要改变个人信息的处理目的，将再次征求您的授权同意。</p>
		<p>2.2.6.在委托我们的合作伙伴（供应商、服务提供商和其他合作伙伴）提供某些服务时，共享您的用户信息。例如，您注册账户或登录时，您同意授权动态时序通过我们的合作伙伴向您发送验证码、进行身份真实性核验。我们的授权合作伙伴无权将共享的个人信息用于本政策规定用途之外的任何其他用途，如要授权合作伙伴改变个人信息的使用目的，将再次征求您的授权同意。</p>
		<p>2.2.7.为提高您使用我们及我们关联公司、合作伙伴提供服务的安全性，确保操作环境安全与识别账号异常状态，保护您或其他用户或公众的人身财产安全免遭侵害，更好地预防钓鱼网站、欺诈、网络漏洞、计算机病毒、网络攻击、网络侵入等安全风险，更准确地识别违反法律法规或动态时序网站相关协议、规则的情况，我们可能使用您的账号信息、并整合有关网络日志以及我们关联公司、合作伙伴合法分享的系信息，来判断您账户及交易风险、进行身份验证、安全事件的检测及防范，并依法采取必要的记录、审计、分析、处置措施。</p>
		<p>我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。在我们与合作伙伴共享信息时，我们会以多种方式保护您的个人信息，包括但不限于：</p>
		<p>1)如具备上述合理事由且需要您授权同意的，我们会在共享前向您告知共享的信息的目的、信息接收方的类型以及可能产生的后果并在取得您授权同意后在共享；</p>
		<p>2)在合作协议层面，我们会严格要求合作伙伴的信息保护义务与责任，我们将与其签署关于数据安全的保护协议，通过协议严格约定合作伙伴的用户信息保密义务，包括信息的保管、使用和流转等均应满足我们的管控要求，接受我们的审核、监督等，一旦有任何违反，我们将立即要求合作伙伴停止相关行为，并采取或要求其采取相应补救措施控制或消除对您的风险，必要时合作伙伴将须承担相应法律责任。</p>
		<p>2.3.转让</p>
		<p>在未获取您明确同意的情况下，我们不会将您的用户信息转让给任何公司、组织和个人，但如动态时序自身发生公司分立、合并等情况下，如涉及到用户信息转让，我们会要求新的持有您用户信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</p>
		<p>2.4.公开披露</p>
		<p>我们仅会在以下情况下，公开披露您的个人信息：</p>
		<p>2.4.1.获得您明确同意后；</p>
		<p>2.4.2.根据法律法规的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会依据要求的个人信息类型和披露方式公开披露您的个人信息。</p>
		<h5>3.我们如何保护、存储、删除您的用户信息</h5>
		<p>3.1.个人信息的保护</p>
		<p>3.1.1.动态时序严格保护您个人信息的安全。我们使用各种安全技术措施和合理可行的方式来保护您的个人信息。</p>
		<p>3.1.2.动态时序采用严格的数据访问权限控制和多重身份认证技术保护个人信息，避免数据被违规使用。我们制定了数据分类分级管理手册、数据合规管理手册等数据安全合规类管理制度，并会举办数据安全合规培训课程，不断增强员工对于保护个人信息重要性的认识。</p>
		<p>3.1.3.我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</p>
		<p>3.1.4.互联网环境并非百分之百安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。如果我们的物理、技术、或管理防护设施遭到破坏、导致信息被非授权访问、公开披露、篡改、或毁坏，导致您的合法权益受损，我们将承担相应的法律责任。</p>
		<p>3.1.5.在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
		<p>3.2.个人信息的存储</p>
		<p>我们按照相关法律法规允许存储的内容范围和期限进行存储，法律规定不可存储的我们不会进行存储。若法律没有明确规定的，我们按照与您签署的各类协议进行处理。</p>
		<p>3.3.用户信息的删除</p>
		<p>如果您要求我们删除属于您的个人信息，请联系我们，我们会按照您的要求予以删除。在删除之前您如果需要对一些信息或记录进行保存的，您需要自行备份。</p>
		<h5>4.Cookie和同类技术的使用</h5>
		<p>您了解并同意，动态时序使用cookie或同类技术来使动态时序网站对用户更友好便捷。Cookie文件是一种很小的数据文件，这些文件会存储在您的计算机上，可以帮您省去为使我们的服务而重复输入注册信息和跟踪您的浏览器的状态。如果您的浏览器允许设置，您可以拒绝动态时序的“Cookies”。</p>
		<h5>5.您的权利</h5>
		<p>5.1.您可以登录动态时序官网注册、查询、修改、删除您的账户信息。建议您使用复杂密码，协助我们保证您的账号安全。您的动态时序账户所有操作视为您本人或者征得您本人/本单位的充分授权而操作，尤其是对于购买、消费、承担责任和义务的操作行为，其法律后果需由您承担。若您的账户被盗号或发生异常，请及时与我们联系作出相应处理。</p>
		<p>5.2.您有权访问和复制您的个人信息，法律法规另有规定除外。如果您想行使数据访问权，可以通过个人中心访问您的账户基本信息、实名认证信息和系统操作日志信息等。如果您无法通过上述方式访问这些个人信息，您可以联系我们的客服。</p>
		<p>5.3.当您发现我们处理的关于您的个人信息有误时，您有权要求我们做出更正。</p>
		<p>5.4.如果您要求我们删除属于您的个人信息，请联系我们，我们会按照您的要求予以删除。在删除之前您如果需要对一些信息或记录进行保存的，您需要自行备份。</p>
		<p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
		<p>5.4.1.如果我们处理用户信息的行为违反法律法规；</p>
		<p>5.4.2.如果我们收集、使用您的用户信息，却未征得您的明确同意；</p>
		<p>5.4.3.如果我们处理个人信息的行为严重违反了与您的约定；</p>
		<p>5.4.4.如果您不再使用我们的产品或服务；</p>
		<p>5.4.5.如果我们停止提供产品或服务，或者个人信息的保存期限已届满；</p>
		<p>5.4.6.如果我们处理您个人信息的目的已实现、无法实现或者为实现处理目的不再必要；</p>
		<p>5.4.7.如果您撤回同意；</p>
		<p>5.4.8.法律法规规定的其他情形。</p>
		<p>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。请您理解，在法律法规规定的保存期限未届满，或者删除从技术上难以实现的，我们将停止除储存和采取必要的安全保护措施之外的处理。</p>
		<p>5.5.当您决定不再使用我们的产品时，您可以按照《用户服务协议》的约定申请注销账户。您注销账户后，我们将删除您的个人信息对其进行匿名化处理。但您知晓并接受，按照有关法律法规的规定，商品和服务信息、交易信息保存时间自交易完成之日起不少于三年；法律、行政法规另有规定的，依照其规定。</p>
		<p>5.6.每个业务功能需要一些基本个人信息才能得以完成。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。当您收回同意后，我们将不再处理相应的个人信息，但您收回同意不影响此前基于您的授权而开展的个人信息处理。</p>
		<p>5.7.为了维护、改进服务，向您提供更符合您个性化需求的信息展示，我们可能对用户画像，以短信通知、电子邮件的形式向您展示、推送消息和可能的商业广告，包括但不限于动态时序产品的新闻以及优惠促销信息，或其他您可能感兴趣的内容。</p>
		<p>5.8.为了响应您的上述请求，我们可能需要您提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在10个工作日内作出答复。对于您的合理请求，我们原则上不收取费用，但多次重复、超出合理限度的请求，我们将视情况收取一定的合理费用。对于那些无端重复、明显不合理或超出必要限度的请求、可能给他人或动态时序的合法权益带来风险的请求，我们可能会予以拒绝。</p>
		<p>在以下情形中，我们将无法响应您的请求：</p>
		<p>5.8.1.与个人信息控制者履行法律法规规定的义务相关的；</p>
		<p>5.8.2.与国家安全、国防安全直接相关的；</p>
		<p>5.8.3.与公共安全、公共卫生、重大公共利益直接相关的；</p>
		<p>5.8.4.与刑事侦查、起诉、审判和执行判决等直接相关的；；</p>
		<p>5.8.5.个人信息控制者有充分证据表明个人信息主体存在主观恶意或滥用权利的；</p>
		<p>5.8.6.出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</p>
		<p>5.8.7.响应个人信息主体的请求将导致个人信息主体或其他个人、组织的合法权益受到严重损害的；</p>
		<p>5.8.8.涉及国家秘密或商业秘密的。</p>
		<h5>6.我们如何处理未成年人的个人信息</h5>
		<p>6.1.我们的产品、网站和服务主要面向企业用户或成年人。如果没有父母或监护人的同意，未成年人不应创建自己的个人信息主体账户。</p>
		<p>6.2.如您是18周岁以下的未成年人，您需在操作前征得监护人的明确同意，但是法律、行政法规另有规定的除外。对于经父母或法定监护人同意而收集未成年人个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护未成年人所必要的情况下使用或公开披露此信息。</p>
		<p>6.3.如果我们发现自己在未事先获得可证实的父母或法定监护人同意的情况下收集了未成年人的个人信息，则会设法尽快删除相关数据。</p>
		<h5>7.您的个人信息如何在全球范围转移</h5>
		<p>原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。如需将您的个人信息进行跨境转移，我们将会单独征求您的授权同意。</p>
		<h5>8.本政策如何更新</h5>
		<p>8.1.本政策适用于动态时序的所有相关服务，随着动态时序服务的变动或扩展，隐私政策的内容可由动态时序随时更新，届时请您关注动态时序官网上公示的最新版本的隐私政策。</p>
		<p>8.2.未经您明确同意，我们不会削减您依据本隐私政策所应享有的权利。对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或浏览页面做特别提示等方式，说明隐私政策的具体变更内容你那个）。本政策所指的重大变更包括但不限于：</p>
		<p>8.2.1.我们的服务模式发生重大变化、如处理个人信息的目的、处理的个人信息类型、个人信息的使用方式等；</p>
		<p>8.2.2.我们在是所有权结构、组织架构等方面发生重大变化。如业务调整、破产并购等引起的所有者变更等；</p>
		<p>8.2.3.个人信息共享、转让或公开披露的主要对象发生变化；</p>
		<p>8.2.4.您参与个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
		<p>8.2.5.我们负责处理个人信息安全的责任部门、联络方式及投诉渠道发生变化时；</p>
		<p>8.2.6.个人信息安全影响评估报告表明存在高风险时。</p>
		<h5>9.如何联系我们</h5>
		<p>9.1.若您有任何疑问或需要，可以通过邮箱service@workatdata.com联系我们。</p>
		<p>9.2.一般情况下，我们将在10个工作日内回复。如果您对我们的回复不满意，特别是我们的个人信息处理行为损害了您的合法权益，您还可以向网信、电信、公安及工商等监管部门进行投诉或举报。</p>
		<router-view></router-view>
    </article>
</template>
<script>
export default {
    namme:'case1',
    data(){
        return{
            
        }
    },
    methods:{
       
    },
    mounted(){
       this.$store.commit('setAboutIndex',2)
    }
}
</script>
<style lang="less" scoped>
	/* 协议正文排版：handoff 文档样式（标题层级 + 正文行高），正文内容未做任何改动 */
	.doc-article {
		padding: 38px 44px 10px;
		background: #fff;
		border: 1px solid #E8EBF0;
		border-radius: 14px;
		h5 {
			font-size: 17px;
			font-weight: 700;
			color: #111827;
			margin: 26px 0 10px;
		}
		p {
			font-size: 14.5px;
			line-height: 1.9;
			color: #374151;
			margin-bottom: 10px;
		}
		a {
			color: #1A56DB;
			word-break: break-all;
		}
		a:hover {
			text-decoration: underline;
		}
	}
	@media (max-width: 620px) {
		.doc-article {
			padding: 24px 20px 4px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/aboutUs/caseChild/case3.vue